if (!customElements.get('hy-ticker')) {
  customElements.define('hy-ticker', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.hy-colgrid__track');
      const slides = [...this.track.children];
      this.count = slides.length;
      if (this.count < 2 || this.ready) return;
      this.ready = true;
      const first = slides[0].cloneNode(true);
      const last = slides[this.count - 1].cloneNode(true);
      [first, last].forEach((c) => { c.setAttribute('aria-hidden', 'true'); c.removeAttribute('data-shopify-editor-block'); });
      this.track.append(first);
      this.track.prepend(last);
      this.index = 1;
      this.jump();
      this.classList.add('is-ready');
      this.querySelector('[data-prev]').addEventListener('click', () => this.go(this.index - 1, true));
      this.querySelector('[data-next]').addEventListener('click', () => this.go(this.index + 1, true));
      this.delay = Number(this.dataset.autoplay || 0) * 1000;
      if (this.delay && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.addEventListener('mouseenter', () => { this.paused = true; });
        this.addEventListener('mouseleave', () => { this.paused = false; });
        this.timer = setInterval(() => { if (!this.paused && !document.hidden) this.go(this.index + 1); }, this.delay + 500);
      }
    }
    disconnectedCallback() { clearInterval(this.timer); }
    jump() {
      this.track.style.transition = 'none';
      this.track.style.transform = `translateX(${-100 * this.index}%)`;
      void this.track.offsetWidth;
      this.track.style.transition = '';
    }
    go(i, user) {
      if (this.busy) return;
      this.busy = true;
      this.index = i;
      this.track.style.transform = `translateX(${-100 * i}%)`;
      clearTimeout(this.settle);
      this.settle = setTimeout(() => {
        if (this.index === 0) { this.index = this.count; this.jump(); }
        else if (this.index === this.count + 1) { this.index = 1; this.jump(); }
        this.busy = false;
      }, 520);
    }
  });
}
